import { render } from "./TruckAddEditFormModal.vue?vue&type=template&id=a8614278&scoped=true&lang=pug"
import script from "./TruckAddEditFormModal.vue?vue&type=script&lang=ts"
export * from "./TruckAddEditFormModal.vue?vue&type=script&lang=ts"

import "./TruckAddEditFormModal.vue?vue&type=style&index=0&id=a8614278&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a8614278"

export default script